<template>
  <div>
    <v-banner v-if="cookieBanner" dark color="darkblue" class="text-center text-lg-left cookie-banner">
      <v-container>
      <v-row class="align-center">
        <v-col cols=12 class="col-lg-auto">
          <v-avatar height="40">
            <v-icon>
              fas fa-cookie-bite
            </v-icon>
          </v-avatar>
        </v-col>
        <v-col cols=12 class="col-lg-auto mr-auto">
          We use third-party <a href="/privacy-cookies">cookies</a> to personalise your experience and to analyse web traffic.
        </v-col>
        <v-col cols=12 class="col-lg-auto">
          <v-btn
            color="primary"
            text
            large
            @click.stop="cookieSidebar = !cookieSidebar"
            :block="$vuetify.breakpoint.xsOnly"
            class="mb-4 mb-sm-0 mr-sm-2"
          >
            Customise
          </v-btn>
          <v-btn
            color="primary"
            large
            depressed
            @click="allowAllCookies()"
            :block="$vuetify.breakpoint.xsOnly"
          >
            Allow All
          </v-btn>
        </v-col>
      </v-row>
      </v-container>
    </v-banner>

    <v-navigation-drawer
      v-model="cookieSidebar"
      temporary
      right
      width="400"
      class="cookie-sidebar"
      app>
      <v-list-item class="my-4 font-weight-bold">
        <v-list-item-content>
          <v-list-item-title>
            Privacy Preference Centre
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon color="light" @click="toggleSidebar">fas fa-times fa-2x</v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-list-item class="mt-4">
        <v-list-item-content>
          When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalised web experience.
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          Because we respect your right to privacy, you can choose not to allow some types of cookies. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <a href="/privacy-cookies">Cookie Policy</a>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-btn
            large
            depressed
            color="primary"
            class="mt-4"
            @click="allowAllCookies()"
          >
            Allow All
          </v-btn>
        </v-list-item-content>
      </v-list-item>
      <v-list>
        <v-list-item class="mt-4 font-weight-bold">
          <v-list-item-content>
            <v-list-item-title>
              Consent Preferences
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-switch
            v-model="essentialCookies"
            disabled
            :label="`Essential Cookies`"
          >
          </v-switch>
        </v-list-item>
        <v-list-item>
          <v-switch
            v-model="analysisCookies"
            :label="`Analytics Cookies`"
          >
          </v-switch>
        </v-list-item>
      </v-list>
      <v-list-item>
        <v-list-item-content>
          <v-btn
            color="primary"
            large
            depressed
            block
            class="mb-8"
            @click="confirmCookieChoices()"
          >
            Allow Selected
          </v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'CookieBanner',
  data () {
    return {
      cookieBanner: false,
      cookieSidebar: null,
      analysisCookies: true,
      essentialCookies: true
    }
  },
  created () {
    this.initialiseCookieBanner()
  },
  methods: {
    allowAllCookies () {
      localStorage.setItem('areEssentialCookiesAccepted', true);
      localStorage.setItem('areAnalysisCookiesAccepted', true);
      this.cookieBanner = false;
      this.cookieSidebar = false
    },
    confirmCookieChoices () {
      localStorage.setItem('areEssentialCookiesAccepted', this.essentialCookies);
      localStorage.setItem('areAnalysisCookiesAccepted', this.analysisCookies);
      this.cookieBanner = false;
      this.cookieSidebar = false
    },
    initialiseCookieBanner () {
      const areEssentialCookiesAccepted = localStorage.getItem('areEssentialCookiesAccepted');
      const areAnalysisCookiesAccepted = localStorage.getItem('areAnalysisCookiesAccepted');
      if (areEssentialCookiesAccepted === null || areAnalysisCookiesAccepted === null) {
        localStorage.setItem('areEssentialCookiesAccepted', false);
        localStorage.setItem('areAnalysisCookiesAccepted', false);
        this.showCookieBanner();
      }
      if (areEssentialCookiesAccepted !== 'true') {
        this.showCookieBanner();
      }
    },
    showCookieBanner () {
      this.cookieBanner = true;
    },
    toggleSidebar () {
      this.cookieSidebar = !this.cookieSidebar
    }
  }
}
</script>

<style scoped>
  .cookie-sidebar {
    font-size: 0.875rem;
  }
  .cookie-banner {
    bottom: 0;
    left: 0;
    position: fixed;
    width: 100%;
    z-index: 4;
  }
</style>
